<template>
    <div style="height: 97vh; overflow: auto;">
        <a-breadcrumb v-if="false">
            <a-breadcrumb-item>Action List</a-breadcrumb-item>
        </a-breadcrumb>
        <div style="margin-top: 10px;">
            <a-date-picker :disabled-date="disabledDate" @change="onDateChange" :inputReadOnly="true" :format="dateFormat" style="width: 150px; margin-left: 10px;"  v-model:value="sdate" />
            <span>&nbsp;-&nbsp;</span>
            <a-date-picker :disabled-date="disabledDate" @change="onDateChange" :inputReadOnly="true" :format="dateFormat" style="width: 150px;" v-model:value="edate" />
            <a-select
                v-model:value="select_source"
                :options="source_options"
                style="width: 200px;"
                @change="handleChangeSource"
            >
            </a-select>
            <a-select
                v-model:value="select_action_name"
                :options="action_name_options"
                style="width: 200px;"
                @change="handleChangeActionName"
            >
            </a-select>
            <a-button type="primary" style="margin-left: 10px;" @click="onDateChange">{{ $t('common.search') }}</a-button>
            <a-button type="default" style="margin-left: 10px;" :disabled="action_list.length == 0"  @click="onExportData">{{ $t('common.export') }}</a-button>
            <a-select
                v-if="store_options.length > 0"
                v-model:value="select_sid"
                :options="store_options"
                style="width: 200px; float: right;"
                @change="handleChangeStore"
            >
            </a-select>
        </div>
        <div v-if="!is_mobile">
            <a-table style="margin-top: 10px;" :columns="columns" :data-source="action_list" :pagination="false">
                <template #bodyCell="{ text }">
                    <span>
                        {{ text }}
                    </span>
                </template>
            </a-table>
            <a-pagination style="padding: 10px 0; background-color: #fff;" :showSizeChanger="false" @change="doLoadMore" v-model:current="current" :total="total_count" show-less-items />
        </div>
        <div style="padding-bottom: 60px;" v-else>
            <a-card style="width: 100%; margin-top: 5px;" v-for="item in action_list" v-bind:key="item.id">
                <p>Date: {{ item.date + ' ' + item.time }}</p>
                <span style="display: block;" v-for="col_item in columns" v-bind:key="col_item.key">
                    <span v-if="col_item.key != 'index' && col_item.key != 'date' && col_item.key != 'time'">{{ col_item.title + " : " + (item[col_item.key] || '') }}</span>
                </span>
            </a-card>
            <div v-if="is_loading" style="width: 100%; text-align: center; padding: 20px;">
                <a-spin></a-spin>
            </div>
            <a-button v-if="current < total_page" @click="doLoadMore" style="width: 100%; margin-top: 5px;">Load more</a-button>
        </div>
     </div>
</template>

<script>
    import { mapActions, mapMutations } from 'vuex';
    import dayjs from 'dayjs';
    import moment from 'moment-timezone';

    import {
    } from '@ant-design/icons-vue';

    export default {
        name: 'ActionListPage',
        components: {
        },
        data() {
            return {
                chain_id: this.$store.state.app.chain_id,
                is_mobile: this.$store.state.app.is_mobile,
                store_list: [],
                columns: [
                    {
                        title: '#',
                        dataIndex: 'index',
                        key: 'index',
                    },
                    {
                        title: 'Shop',
                        dataIndex: 'sname',
                        key: 'sname',
                    },
                    {
                        title: 'Module',
                        dataIndex: 'business',
                        key: 'business',
                    },
                    {
                        title: 'Action Details',
                        dataIndex: 'action_log',
                        key: 'action_log',
                    },
                    {
                        title: 'Operation Time',
                        dataIndex: 'time',
                        key: 'tiem',
                    },
                    {
                        title: 'Platfrom',
                        dataIndex: 'source',
                        key: 'source',
                    },
                    {
                        title: 'IP',
                        dataIndex: 'ip',
                        key: 'ip',
                    }
                ],
                disabledDate: (current) => {
                    return current && current > moment().subtract(0, 'days');
                },
                dateFormat: 'YYYY-MM-DD',
                sdate: dayjs(moment().subtract(30, 'days').format(this.dateFormat), this.dateFormat),
                edate: dayjs(moment().subtract(0, 'days').format(this.dateFormat), this.dateFormat),
                store_options: [],
                select_sid: '',
                current: 1,
                total_count: 0,
                total_page: 0,
                action_list: [],
                source_options: [
                    {
                        value: '',
                        label: 'All Sources',
                    },
                    {
                        value: 'web',
                        label: 'Web Backend',
                    },
                    {
                        value: 'app',
                        label: 'App',
                    },
                ],
                select_source: '',
                select_action_name: '',
                action_name_options: [
                    {
                        value: '',
                        label: 'All Actions',
                    },
                    {
                        value: 'inventory',
                        label: 'Inventory',
                    },
                    {
                        value: 'allow_times',
                        label: 'Allow Times',
                    },
                    {
                        value: 'waitlist',
                        label: 'Waitlist',
                    },
                    {
                        value: 'reservation',
                        label: 'Reservation',
                    },
                ],
            };
        },
        created() {
            this.do_get_store_list();
        },
        computed: {},
        methods: {
            ...mapActions({
                getActionList: 'action/getActionList',
                getStoreList: 'app/getStoreList',
                exportActionList: 'action/exportActionList',
            }),
            ...mapMutations({
                setLoading: 'app/APP_SET_LOADING',
                setSelectSid: 'app/APP_SET_SELECT_SID'
            }),
            async do_get_action_list() {
                this.is_loading = true;
                let sdate = dayjs(this.sdate).format(this.dateFormat);
                let edate = dayjs(this.edate).format(this.dateFormat);

                let action_list = await this.getActionList({
                    sid: this.select_sid,
                    page: this.current,
                    page_size: 10,
                    stime: sdate,
                    etime: edate,
                    source: this.select_source,
                    action_name: this.select_action_name,
                });

                if (action_list.code == 100000) {
                    this.action_list = action_list.data.list;
                    this.total_count = action_list.data.total_count;
                    this.total_page = action_list.data.total_page;
                }
            },
            async do_get_store_list() {
                let store_list = await this.getStoreList({
                    chain_id: this.chain_id,
                    page: 1,
                    size: 0
                });

                this.store_options = store_list.map(item => {
                    return {
                        value: item.sid,
                        label: item.nick_name,
                    };
                });

                if (!this.select_sid) {
                    this.setSelectSid(this.store_options[0] && this.store_options[0].value || '');
                    this.select_sid = this.store_options[0] && this.store_options[0].value || '';
                }

                this.do_get_action_list();
            },
            handleChangeStore() {
                this.current = 1;
                this.setSelectSid(this.select_sid);
                this.do_get_action_list();
            },
            doLoadMore() {
                if (this.is_mobile) {
                    this.current += 1;
                }

                this.do_get_action_list();
            },
            onDateChange() {
                this.current = 1;
                this.do_get_action_list();
            },
            onExportData() {
                let sdate = dayjs(this.sdate).format(this.dateFormat);
                let edate = dayjs(this.edate).format(this.dateFormat);

                let data = {
                    sid: this.select_sid,
                    stime: sdate,
                    etime: edate,
                    source: this.select_source,
                    action_name: this.select_action_name,
                };

                this.exportActionList(data).then(res => {
                    let uploadExcel = fileName => {
                        const blob = new Blob([res], {
                            type:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8"
                        });
                        const url = URL.createObjectURL(blob);
                        const aLink = document.createElement("a");
                        aLink.setAttribute("download", fileName);
                        aLink.setAttribute("href", url);
                        document.body.appendChild(aLink);
                        aLink.click();
                        document.body.removeChild(aLink);
                        URL.revokeObjectURL(blob);
                    };
                    uploadExcel("action_list_" + sdate + '_' + edate + ".xlsx");
                });
            }
        }
    };
</script>

<style scoped>
</style>
